export const UPLOAD_REMOVE_ICON = <svg viewBox="0 0 36 36" width={12} height={12}>
    <path d="M6.2,3.5L3.5,6.2c-0.7,0.7-0.7,1.9,0,2.7l9.2,9.2l-9.2,9.2c-0.7,0.7-0.7,1.9,0,2.7l2.6,2.6   c0.7,0.7,1.9,0.7,2.7,0l9.2-9.2l9.2,9.2c0.7,0.7,1.9,0.7,2.7,0l2.6-2.6c0.7-0.7,0.7-1.9,0-2.7L23.3,18l9.2-9.2   c0.7-0.7,0.7-1.9,0-2.7l-2.6-2.6c-0.7-0.7-1.9-0.7-2.7,0L18,12.7L8.8,3.5C8.1,2.8,6.9,2.8,6.2,3.5z"/>
</svg>;

export const UPLOAD_ICON = <svg   height="24" viewBox="0 0 24 24" width="24" >
    <path d="M19,22H5c-1.7,0-3-1.3-3-3v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v4c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-4c0-0.6,0.4-1,1-1
	s1,0.4,1,1v4C22,20.7,20.7,22,19,22z"/>
    <path d="M17,9c-0.3,0-0.5-0.1-0.7-0.3L12,4.4L7.7,8.7c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0l5,5
	c0.4,0.4,0.4,1,0,1.4C17.5,8.9,17.3,9,17,9z"/>
    <path d="M12,16c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1s1,0.4,1,1v12C13,15.6,12.6,16,12,16z"/>
</svg>;